export default {
  title: '基本パッケージのダウンロード',
  select: '品質を選択してください',
  lowQuality: '低品質',
  middleQuality: '中品質',
  highQuality: '高品質',
}
